import { Route, Routes, Navigate } from 'react-router-dom';

import IndexPage from '@/pages/index';
import LoginPage from '@/pages/login';
import AuthGuard from '@/middleware/auth-guard';
import GuestGuard from '@/middleware/guest-guard';
import OrganizationsPage from '@/pages/organizations';
import OrganizationsDeletedPage from '@/pages/organizations/deleted';
import DomainsPage from '@/pages/domains';
import DomainsDeletedPage from '@/pages/domains/deleted';
import SessionsDeletedPage from '@/pages/sessions/deleted';
import UsersPage from '@/pages/users';
import ErrorzPage from '@/pages/errorz';
import BlockedUsersPage from '@/pages/blocked-users';
import RolesPage from '@/pages/roles';
import CdnManagerPage from '@/pages/cdn-manager';
import CdnProvidersPage from '@/pages/cdn-providers';
import CdnPage from '@/pages/cdn';
import NotificationsPage from '@/pages/notifications';
import ExperimentsPage from '@/pages/experiments';
import ExperimentDetailPage from '@/pages/experiments/[id]';
import ActivityLogsPage from '@/pages/activity-logs';
import LeadsPage from '@/pages/leads';
import LeadDetailPage from '@/pages/leads/[id]';
import LeadsViewerPage from '@/pages/leads/viewer';
import ContactMessagesPage from '@/pages/relationships/contact-messages';
import ContactMessageDetailPage from '@/pages/relationships/contact-messages/[id]';
import ContactSectionsPage from '@/pages/settings/contact-sections';
import AiModelsPage from '@/pages/settings/ai-models';
import AiUsagePage from '@/pages/settings/ai-usage';
import SettingsLandingPage from '@/pages/settings';
import ContactPage from '@/pages/contact';
import PlansPage from '@/pages/cms/plans';

function App() {
  return (
    <Routes>
      {/* Public contact route */}
      <Route element={<ContactPage />} path="/contact" />

      {/* Guest-only route: /login */}
      <Route element={<GuestGuard />}>
        <Route element={<LoginPage />} path="/login" />
      </Route>

      {/* Protected routes */}
      <Route element={<AuthGuard />}>
        <Route element={<IndexPage />} path="/" />
        <Route element={<OrganizationsPage />} path="/organizations" />
        <Route element={<OrganizationsDeletedPage />} path="/organizations/deleted" />
        <Route element={<DomainsPage />} path="/domains" />
        <Route element={<DomainsDeletedPage />} path="/domains/deleted" />
        <Route element={<SessionsDeletedPage />} path="/sessions/deleted" />
        <Route element={<UsersPage />} path="/users" />
        <Route element={<ErrorzPage />} path="/reports/errorz" />
        <Route element={<BlockedUsersPage />} path="/reports/blocked-users" />
        <Route element={<RolesPage />} path="/roles" />
        <Route element={<CdnManagerPage />} path="/cdn-manager" />
        <Route element={<CdnProvidersPage />} path="/cdn-providers" />
        <Route element={<CdnPage />} path="/cdn" />
        <Route element={<NotificationsPage />} path="/reports/notifications" />
        <Route element={<ExperimentsPage />} path="/experiments" />
        <Route element={<ExperimentDetailPage />} path="/experiments/:id" />
        <Route element={<ActivityLogsPage />} path="/reports/activity-logs" />
        <Route element={<LeadsPage />} path="/relationships/leads" />
        <Route element={<LeadDetailPage />} path="/relationships/leads/:id" />
        <Route element={<LeadsViewerPage />} path="/relationships/leads/viewer" />
        <Route element={<ContactMessagesPage />} path="/relationships/contact-messages" />
        <Route element={<ContactMessageDetailPage />} path="/relationships/contact-messages/:id" />
        <Route element={<SettingsLandingPage />} path="/settings" />
        <Route element={<ContactSectionsPage />} path="/settings/contact-sections" />
        <Route element={<AiModelsPage />} path="/settings/ai-models" />
        <Route element={<AiUsagePage />} path="/reports/ai-usage" />
        <Route element={<PlansPage />} path="/cms/plans" />
      </Route>

      {/* Fallback redirect to home */}
      <Route element={<Navigate replace to="/" />} path="*" />
    </Routes>
  );
}

export default App;
